/**
 * Footer/social `href` values must be absolute. Values like `wa.me/852…` (no scheme) are
 * treated by the browser as paths on the current site and break. DNS errors for `wa.me`
 * can also be local network / DNS (try another network or DNS 8.8.8.8).
 */
export function ensureAbsoluteWebUrl(input: string | undefined | null): string {
  const t = (input || '').trim()
  if (!t) return ''
  if (/^https?:\/\//i.test(t)) return t
  if (/^\/\//.test(t)) return `https:${t}`
  if (/^wa\.me\//i.test(t) || /^api\.whatsapp\.com\//i.test(t) || /^web\.whatsapp\.com\//i.test(t)) {
    return `https://${t}`
  }
  if (/^facebook\.com\//i.test(t) || /^m\.facebook\.com\//i.test(t) || /^www\.facebook\.com\//i.test(t)) {
    return `https://${t}`
  }
  return t
}
